module.exports = __webpack_public_path__ + "fonts/iconfont.56b2fa6a.woff2";